export default __webpack_public_path__ + "static/media/sleet.c3102e2c.jpg";